ixModuleRouting('impactx.greetingcard', {
    '/productgreetingcardlist': {
        templateUrl: 'modules/greetingcard/templates/productgreetingcardlist.html',
        controller: 'ProductGreetingCardListCtrl',
        controllerAs: 'productGreetingCardListCtrl',
        process: 'ProductGreetingCard',
        workspace: 'content'
    },
    '/productgreetingcard/:id': {
        template: '<ixa-product-greeting-card></ixa-product-greeting-card>',
        templateUrl: 'modules/greetingcard/templates/productgreetingcard.html',
        controller: 'ProductGreetingCardCtrl',
        controllerAs: 'productGreetingCardCtrl',
        process: 'ProductGreetingCard',
        workspace: 'content'
    },
    "/greetingcardtemplatelist": {
        template: "<ixa-greetingcardtemplate-list></ixa-greetingcardtemplate-list>",
        process: "GreetingCardTemplateList",
        workspace: "admin",
    },
    "/greetingcardtemplate/:id": {
        template: "<ixa-greetingcardtemplate-dialog></ixa-greetingcardtemplate-dialog>",
        process: "GreetingCardTemplateList",
        workspace: "admin",
    }
});